export const UTIL_CONSTS = {
    SET_MOBILE: "SET_MOBILE",
    CHANGE_HEADER_TITLE: "CHANGE_HEADER_TITLE",
    EVENT_COLORS: "EVENT_COLORS",
    SET_FULL_WIDTH: "SET_FULL_WIDTH",
    UPDATE_MENU_ACTIVE: "UPDATE_MENU_ACTIVE",
    OPEN_MENU: "OPEN_MENU",
    DETECTED_EXTENSION: "DETECTED_EXTENSION"
};
